<template>
  <v-app id="inspire">
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>{{ $vuetify.lang.t('$vuetify.user.forgottenPassword') }}</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form @submit="submitResetPassword">
                  <v-text-field
                    v-if="!token"
                    :hide-details="!token"
                    label="Email"
                    name="email"
                    type="email"
                    v-model="email"
                    outlined
                    prepend-icon="$vuetify.icons.user"
                  ></v-text-field>

                  <template v-if="token">
                    <v-text-field
                      id="password"
                      :label="$vuetify.lang.t('$vuetify.user.password')"
                      name="password"
                      prepend-icon="$vuetify.icons.lock"
                      type="password"
                      v-model="password"
                      outlined
                    ></v-text-field>

                    <v-text-field
                      hide-details
                      id="passwordConfirm"
                      :label="$vuetify.lang.t('$vuetify.user.passwordConfirm')"
                      name="passwordConfirm"
                      prepend-icon="$vuetify.icons.lock"
                      type="password"
                      v-model="passwordConfirm"
                      outlined
                    ></v-text-field>
                  </template>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <router-link class="text-decoration-none" :to="{ name: 'login' }">
                  <v-btn color="grey lighten-2">Login</v-btn>
                </router-link>
                <div class="flex-grow-1" />
                <v-btn color="primary" @click="sendEmail" :disabled="!email">{{
                  $vuetify.lang.t('$vuetify.labels.send')
                }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from 'axios';

export default {
  props: { source: String },
  data() {
    return {
      token: null,
      email: null,
      password: null,
      passwordConfirm: null,
    };
  },
  methods: {
    submitResetPassword() {
      const { email, password } = this;
      this.attemptLogin({ email, password }).then(() => {
        this.$router.push({ name: 'search' });
      });
    },
    async sendEmail() {
      await axios
        .post('passwords/user', { email: this.email })
        .then(() => {
          this.$store.dispatch(
            'alerts/OPEN_SUCCESS',
            this.$vuetify.lang.t('$vuetify.messages.sendPasswordResetSuccess')
          );
          this.$router.push({ name: 'login' });
        })
        .catch(error => {
          if (error.response.status === 429) {
            this.$store.dispatch('alerts/OPEN_ERROR', this.$vuetify.lang.t('$vuetify.messages.APICallsNumberExceeded'));
          } else if (error.response.data.errors) {
            this.$store.dispatch('alerts/OPEN_ERROR', error.response.data.errors[0].message);
          } else {
            this.$store.dispatch('alerts/OPEN_ERROR', error.response.data.message);
          }
        });
      this.token = 'template';
    },
  },

  created() {},
};
</script>

<style>
.text-decoration-none {
  text-decoration: none;
}
</style>
